export default __webpack_public_path__ + "static/media/11.e7bd550b.png";